<template>
  <div class="box">
    <div id="echart"></div>
  </div>
</template>
<script>
export default {
  props: {
		list: {
			type: [String,Array],
			default: "",
		},

	},
  data() {
    return {
      myChart: null,
      option:{
        legend: {},
        tooltip: {},
        dataset: {
          source: [
            ["product", "", "", "", "", "", "", "", "", "", "", ""],
            ["新增场所数", 43.3, 85.8, 93.7, 93.7, 93.7, 93.7],
            ["场所数", 83.1, 73.4, 55.1, 93.7, 93.7, 93.7],
            ["隐患数", 86.4, 65.2, 82.5, 93.7, 93.7, 93.7],
            ["新增隐患数", 72.4, 53.9, 39.1, 93.7, 93.7, 93.7],
          ],
        },
        xAxis: { type: "category" },
        yAxis: {},
        series: [{ type: "bar" }, { type: "bar" }, { type: "bar" }, { type: "bar" }],
      },
      data_type:[],
    };
  },
  watch:{
    list(){
      this.getList()
    }
  },
  mounted() {
    

    window.addEventListener("resize", () => {

      this.myChart.resize();
    });
    
  },
  methods: {
    getList(){
      this.data_type=[]
      this.option.series=[]
      this.option.dataset.source[1]=["新增场所数"]
      this.option.dataset.source[2]=["场所数"]
      this.option.dataset.source[3]=["隐患数"]
      this.option.dataset.source[4]=["新增隐患数"]
        this.list.map((v)=>{
          this.data_type.push(v.name)
            this.option.series.push({ type: "bar" })
            this.option.dataset.source[1].push(v.place_count)
            this.option.dataset.source[2].push(v.place_new_count)
            this.option.dataset.source[3].push(v.hidden_count)
            this.option.dataset.source[4].push(v.hidden_new_count)
        })
        this.myChart = this.$echarts.init(document.getElementById("echart"));
        this.option.dataset.source[0]=["product",...this.data_type];
      
      // console.log(this.option.dataset.source[0])
      this.myChart.setOption(this.option);
    }
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  height: 100%;
}
#echart {
  width: 100%;
  height: 100%;
}
</style>